import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "24",
  fill: "0",
  viewBox: "0 0 25 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#000",
      d: "M12.836 6.872A5.12 5.12 0 0 0 7.709 12a5.12 5.12 0 0 0 5.127 5.128A5.12 5.12 0 0 0 17.962 12a5.12 5.12 0 0 0-5.126-5.128m0 8.462A3.34 3.34 0 0 1 9.503 12a3.336 3.336 0 0 1 3.332-3.334A3.336 3.336 0 0 1 16.169 12a3.34 3.34 0 0 1-3.332 3.334m6.532-8.671c0 .664-.536 1.196-1.196 1.196a1.196 1.196 0 1 1 1.196-1.196m3.395 1.213c-.076-1.602-.442-3.02-1.615-4.19-1.17-1.17-2.588-1.535-4.19-1.616-1.65-.093-6.599-.093-8.25 0-1.597.076-3.016.442-4.19 1.611-1.173 1.17-1.534 2.589-1.614 4.19-.094 1.652-.094 6.601 0 8.253.075 1.602.441 3.02 1.615 4.19s2.588 1.535 4.19 1.616c1.65.093 6.598.093 8.25 0 1.601-.076 3.02-.442 4.189-1.616 1.169-1.17 1.535-2.588 1.615-4.19.094-1.652.094-6.596 0-8.248m-2.133 10.02a3.37 3.37 0 0 1-1.9 1.9c-1.317.523-4.44.402-5.895.402s-4.582.116-5.894-.401a3.38 3.38 0 0 1-1.9-1.902c-.522-1.316-.402-4.44-.402-5.895s-.116-4.583.402-5.895a3.38 3.38 0 0 1 1.9-1.902c1.317-.522 4.44-.401 5.895-.401s4.582-.116 5.894.401a3.37 3.37 0 0 1 1.9 1.902c.522 1.316.402 4.44.402 5.895s.12 4.583-.402 5.895"
    }, null, -1)
  ]))]))
}
export default { render: render }